import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/* Compact page title: 22px heading + an (i) that opens the "what this page does" text.
   Replaces the old 30–40px h1 + full paragraph that ate half a phone screen. */
export function PageTitle({ title, about, testid, className = "" }) {
  return (
    <div className={`flex items-center gap-1.5 min-w-0 ${className}`} data-testid={testid ? `${testid}-wrap` : undefined}>
      <h1 className="font-heading text-[22px] font-extrabold tracking-tight leading-tight min-w-0 break-words flex items-center gap-2 [&_svg]:h-5 [&_svg]:w-5 [&_svg]:shrink-0" data-testid={testid}>{title}</h1>
      {about && (
        <Popover>
          <PopoverTrigger asChild>
            <button type="button" aria-label="About this page" data-testid={testid ? `${testid}-about` : "page-about"}
              className="h-7 w-7 inline-flex items-center justify-center rounded-full text-ink/40 hover:text-ink hover:bg-ink/5 transition-colors shrink-0">
              <Info className="h-4 w-4" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" sideOffset={6} className="w-80 max-w-[calc(100vw-2rem)] rounded-xl text-[13px] leading-relaxed text-ink/80" data-testid={testid ? `${testid}-about-content` : "page-about-content"}>
            {about}
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
}
